export const pushEventOnDataLayer = (eventName: string, eventData: { [key: string]: string }): void => {
    if ('dataLayer' in window) {
        (window?.dataLayer as Array<Record<string, string>>).push({
            event: eventName,
            ...eventData
        })
    }
}
